import {
  AsyncActionState,
  asyncActionStateMatchers,
  invoke,
  setupSlice,
} from '@owl-frontend/redux';
import { fetchEvents } from '../../api/events/client';
import type { DossierEvent } from '../../api/events/interface';

export interface EventsState {
  events: {
    [dossier_id: string]: DossierEvent[];
  };
  actions: {
    fetchEvents: AsyncActionState<DossierEvent[]>;
  };
}

const initialState: EventsState = {
  events: {},
  actions: {
    fetchEvents: { status: 'uninitialized' },
  },
};

const slice = setupSlice('events', initialState)
  .addAsyncSagas({
    fetchEvents: invoke(fetchEvents),
  })
  .addReducers({
    'fetchEvents/fulfilled': (state, action) => {
      state.events[action.meta.arg] = action.payload;
    },
  });

export const actions = slice.actions;
export default slice.addExtra(asyncActionStateMatchers(actions).all());
